import { render } from "./PaperModal.vue?vue&type=template&id=815daf18"
import script from "./PaperModal.vue?vue&type=script&lang=js"
export * from "./PaperModal.vue?vue&type=script&lang=js"

import "./PaperModal.vue?vue&type=style&index=0&id=815daf18&lang=less"

import exportComponent from "/codebuild/output/src1353221341/src/NewSmartDash/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__